import React from "react";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

import { Logo } from "./helpers/Logos";

const LogoName = () => {
    return (
        <React.Fragment>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                {Logo(40,40)}
                <Typography
                    variant="h6"
                    noWrap
                    component="a"
                    sx={{
                        mr: 2,
                        display: { xs: 'none', md: 'flex' },
                        fontFamily: 'tahoma', //'monospace'
                        fontWeight: 550,
                        // letterSpacing: '.3rem',
                        color: 'white',
                        textDecoration: 'none',
                        flexGrow: 1,
                        // height: 40
                    }}
                >
                    Valucadi
                </Typography>
            </Stack>
        </React.Fragment>
    )
}

export default LogoName